import React from 'react';
import Card from './Card';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import isMobile from 'is-mobile';
import _ from 'lodash';
import './HorizontalCards.css';

const HorizontalCards = props => {
  const { parent, items, itemType, title, showMore, width, height, customImage } = props;
  const ArrowLeft = props.arrowLeft || <Button circular icon="angle right" />;
  const ArrowRight = props.arrowRight || <Button circular icon="angle left" />;

  let totalItemsWidth = 0;
  const cards = [];
  const seenItemKeys = new Set();
  if (items) {
    items.forEach((item, index) => {
      const itemKey = itemType === 'designs' ? String(item._id) : JSON.stringify(item);
      if (seenItemKeys.has(itemKey)) {
        return;
      }
      seenItemKeys.add(itemKey);

      const ratio = item.width ? item.width / item.height : 1;
      if (item.type === 'Video') {
        totalItemsWidth = 110 * ratio;
      } else {
        totalItemsWidth += height * ratio;
      }
      if (index !== 0 && width && totalItemsWidth > width) {
        return;
      }
      totalItemsWidth += 24; // Card left-padding
      if (itemType === 'designs') {
        const srcSet = [];
        srcSet.push(`${process.env.REACT_APP_FILE_SERVER}/resources/${itemType}/${item._id}/thumbnail_large.png`);
        for (let i = 1; i < item.pagesCount; i++) {
          srcSet.push(
            `${process.env.REACT_APP_FILE_SERVER}/resources/${itemType}/${item._id}-${i + 1}/thumbnail_large.png`,
          );
        }
        cards.push(<Card key={itemKey} srcSet={srcSet} height={height} width={height * ratio} />);
      } else {
        const srcSet = [parent === 'Startup' ? item.src.replace('thumbnail', 'thumbnail_large') : item.src];
        if (item.type === 'Template') {
          const imageSize = parent === 'Startup' ? 'thumbnail_large' : 'thumbnail';
          const extension = _.get(item, 'data.extension', 'png');
          for (let i = 1; i < _.get(item, 'data.pages', []).length; i++) {
            srcSet.push(
              `${process.env.REACT_APP_FILE_SERVER}/resources/templates/${item.data.id}-${i +
                1}/${imageSize}.${extension}`,
            );
          }
        }
        cards.push(
          <Card
            key={itemKey}
            item={item}
            srcSet={srcSet}
            height={item.height < height ? item.height : height}
            width={height * ratio}
            customImage={customImage && (item => customImage({ key: index, photo: item }, itemType))}
          />,
        );
      }
    });
  }

  return (
    <div className={`horizontalCards ${_.get(props, 'className', '')}`}>
      {(title || showMore) && (
        <header>
          <div>
            {title && (
              <h3>
                <span onClick={props.onTitleClick} style={props.onTitleClick ? { cursor: 'pointer' } : {}}>
                  {title}
                </span>
              </h3>
            )}
          </div>
          <div className="show-more">{showMore && <span onClick={props.onShowMoreClick}>{showMore}</span>}</div>
        </header>
      )}
      <ScrollMenu
        data={cards}
        arrowLeft={ArrowLeft}
        arrowRight={ArrowRight}
        alignCenter={false}
        hideSingleArrow={true}
        hideArrows={parent === 'VSidebar'}
        dragging={isMobile()}
        rtl={document.documentElement.dir === 'rtl'}
        wheel={false}
        onSelect={props.onItemSelect}
      />
    </div>
  );
};

HorizontalCards.propTypes = {
  parent: PropTypes.string,
  items: PropTypes.array,
  itemType: PropTypes.string,
  title: PropTypes.string,
  showMore: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  customImage: PropTypes.func,
  onTitleClick: PropTypes.func,
  onShowMoreClick: PropTypes.func,
  onItemSelect: PropTypes.func,
  className: PropTypes.string,
  arrowLeft: PropTypes.element,
  arrowRight: PropTypes.element,
};

export default HorizontalCards;
